import React from 'react';
import { Redirect } from 'react-router-dom';
import aisle from '../../pages/aisle';
import intro from '../../pages/intro';
import { _route } from '../../utils';
import * as permissions from '../permissions';

export default [
  { path: '/aisle', component: <Redirect to={_route('aisle')} /> },
  { path: '/aisle/intro', component: intro.AisleIntro },
  { path: '/aisle/home', component: aisle.AisleDominator },
  { path: '/aisle/overview', component: aisle.AisleOverview },
  { path: '/aisle/create', component: aisle.AisleDominatorCreate },
  { path: '/aisle/list', component: aisle.AisleDominatorList, permission: permissions.PERM_AISLE_ACTIVE_LIST },
  { path: '/aisle/results', component: aisle.AisleDominatorResult, permission: permissions.PERM_AISLE_STATS_PERMISSION },
  { path: '/aisle/list/:id/:key/report', component: aisle.AisleDominatorReport },
  { path: '/aisle/:id/edit', component: aisle.AisleEditDominator },
  { path: '/aisle/spot-selection', component: aisle.AisleDominatorSpotSelection },
  { path: '/aisle/:id/report', component: aisle.AisleDominatorReport },
  { path: '/aisle/:id/activity', component: aisle.AisleActivity },
  { path: '/aisle/market-stream', component: aisle.AisleMarketStream },
  { path: '/aisle/market-stream/list', component: aisle.AisleMarketStream },
  { path: '/aisle/market-stream/:campaignId/launch', component: aisle.AisleMarketStreamConfig },
];
